import { domainProvider } from '../../domain/domainProvider'

const S3URL = `https://frontend-assets.${domainProvider.TARGET_DOMAIN}`

export const s3URL = {
  student(url: string) {
    return `${S3URL}/student/${url}`
  },
  teacher(url: string) {
    return `${S3URL}/teacher/${url}`
  },
  common(url: string) {
    return `${S3URL}/common/${url}`
  },
  homepage(url: string) {
    return `${S3URL}/homepage/${url}`
  },
  font(url: string) {
    return `${S3URL}/font/${url}`
  },
  mathflatAssetsBucket: {
    student(url: string) {
      return `${S3URL}/student/${url}`
    },
    teacher(url: string) {
      return `${S3URL}/teacher/${url}`
    },
    common(url: string) {
      return `${S3URL}/common/${url}`
    },
    font(url: string) {
      return `${S3URL}/font/${url}`
    },
    graphic(url: string) {
      return `${S3URL}/graphic/${url}`
    },
  },
}
